import { gql } from "@apollo/client"

export const SET_TEST_VALUE = gql`
  mutation SetTestValue($a: String, $b: String) {
    setTestValue(a: $a, b: $b) @client {
      a
      b
    }
  }
`

export const ADD_ENTRY = gql`
  mutation CreateEntry(
    $key: String
    $date: String
    $image: String
    $text: String
    $type: String
    $pinned: Boolean
    $review: String
    $month: String
    $year: String
    $tags: String
  ) {
    createEntry(
      key: $key
      date: $date
      image: $image
      text: $text
      type: $type
      pinned: $pinned
      review: $review
      month: $month
      year: $year
      tags: $tags
    ) {
      success
      id
      data
      error
    }
  }
`
export const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($settings: String) {
    updateUserSettings(settings: $settings) {
      success
      id
      settings
    }
  }
`
export const UPDATE_ENTRY = gql`
  mutation UpdateEntry(
    $key: String
    $date: String
    $image: String
    $text: String
    $type: String
    $pinned: Boolean
    $review: String
    $reflection: String
    $month: String
    $year: String
    $updateSource: String
    $tags: String
  ) {
    updateEntry(
      key: $key
      date: $date
      image: $image
      text: $text
      type: $type
      pinned: $pinned
      review: $review
      reflection: $reflection
      month: $month
      year: $year
      updateSource: $updateSource
      tags: $tags
    ) {
      success
      key
      data
      error {
        ui
        display
        code
        message
      }
    }
  }
`

export const DELETE_ENTRY = gql`
  mutation DeleteEntry($key: String) {
    deleteEntry(key: $key) {
      success
      key
    }
  }
`

export const PIN_ENTRY = gql`
  mutation PinEntry($key: String) {
    pinEntry(key: $key) {
      success
      key
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($uid: String) {
    deleteUser(uid: $uid) {
      success
      uid
      error
    }
  }
`

export const UPDATE_MONTHLY_REVIEW = gql`
  mutation UpdateMonthlyReview($data: Object) {
    updateMonthlyReview(data: $data) @client {
      success
      data
    }
  }
`

export const ADD_EVENT_LOG = gql`
  mutation CreateEventLog(
    $date: String
    $month: String
    $year: String
    $entryDate: String
    $eventName: String
    $eventData: String
    $userInformation: String
  ) {
    createEventLog(
      date: $date
      month: $month
      year: $year
      entryDate: $entryDate
      eventName: $eventName
      eventData: $eventData
      userInformation: $userInformation
    ) {
      success
      id
      key
    }
  }
`
export const CHANGE_CREDIT_CARD = gql`
  mutation ChangeCreditCardMutation($source: String!, $last4: String!) {
    changeCreditCard(source: $source, last4: $last4) {
      success
      error
    }
  }
`

export const SET_USER_PLAN = gql`
  mutation SetUserPlan($planId: String) {
    setUserPlan(planId: $planId) {
      success
      error {
        message
      }
    }
  }
`
